import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "حاسبة الوقت والزمن - جمع وطرح الوقت بالأيام والساعات والدقائق";
const DESCRIPTION =
  "حاسبة الوقت والزمن المجانية تساعدك على إضافة أو طرح قيم الوقت بالأيام، الساعات، الدقائق، والثواني بسهولة ودقة. احسب الفترات الزمنية، مدة المشاريع، ساعات العمل، وأوقات السفر بكل سهولة";
const KEYWORDS =
  "حاسبة الوقت, حاسبة الزمن, جمع الوقت, طرح الوقت, حساب الساعات, حساب المدة الزمنية, جمع الساعات والدقائق, حساب وقت العمل, حاسبة المدة, تحويل الوقت";
const OG_URL = "https://do-calculate.com/calculator/ar/time-calculator/";
// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "حاسبة الوقت والزمن",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "الرئيسية",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "الحاسبات",
        item: "https://do-calculate.com/ar/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "حاسبة الوقت",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "كيف أستخدم حاسبة الوقت؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "أدخل الوقت الأول بالأيام والساعات والدقائق والثواني، ثم اختر العملية (جمع أو طرح)، وأدخل الوقت الثاني، ثم اضغط على زر احسب للحصول على النتيجة.",
        },
      },
      {
        "@type": "Question",
        name: "ما هي استخدامات حاسبة الوقت؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "تُستخدم حاسبة الوقت في حساب ساعات العمل، مدة المشاريع، أوقات السفر، جدولة المواعيد، حساب فترات التدريب، وأي عمليات حسابية تتعلق بالوقت.",
        },
      },
    ],
  },
];

// Helper component for time input groups
const TimeInputGroup = ({ day, hour, min, sec, setDay, setHour, setMin, setSec }) => (
  <div className="d-flex flex-wrap gap-2 justify-content-center">
    <div className="form-floating mb-2" style={{ width: "80px" }}>
      <input type="number" className="form-control" placeholder="يوم" value={day} onChange={(e) => setDay(e.target.value)} min="0" />
      <label>يوم</label>
    </div>
    <div className="form-floating mb-2" style={{ width: "80px" }}>
      <input type="number" className="form-control" placeholder="ساعة" value={hour} onChange={(e) => setHour(e.target.value)} min="0" max="23" />
      <label>ساعة</label>
    </div>
    <div className="form-floating mb-2" style={{ width: "80px" }}>
      <input type="number" className="form-control" placeholder="دقيقة" value={min} onChange={(e) => setMin(e.target.value)} min="0" max="59" />
      <label>دقيقة</label>
    </div>
    <div className="form-floating mb-2" style={{ width: "80px" }}>
      <input type="number" className="form-control" placeholder="ثانية" value={sec} onChange={(e) => setSec(e.target.value)} min="0" max="59" />
      <label>ثانية</label>
    </div>
  </div>
);
function TimeCalculator() {
  const [day1, setDay1] = useState("");
  const [hour1, setHour1] = useState("");
  const [minute1, setMinute1] = useState("");
  const [second1, setSecond1] = useState("");
  const [day2, setDay2] = useState("");
  const [hour2, setHour2] = useState("");
  const [minute2, setMinute2] = useState("");
  const [second2, setSecond2] = useState("");
  const [type, setType] = useState("add");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculateTime = () => {
    // Validate inputs
    const inputs = [day1, hour1, minute1, second1, day2, hour2, minute2, second2];
    const hasNegative = inputs.some(input => input && parseFloat(input) < 0);
    if (hasNegative) {
      setError("يُرجى إدخال قيم موجبة فقط");
      setResult(null);
      return;
    }
    // Convert all to seconds
    const totalSeconds1 =
      (parseInt(day1) || 0) * 24 * 60 * 60 +
      (parseInt(hour1) || 0) * 60 * 60 +
      (parseInt(minute1) || 0) * 60 +
      (parseInt(second1) || 0);
    const totalSeconds2 =
      (parseInt(day2) || 0) * 24 * 60 * 60 +
      (parseInt(hour2) || 0) * 60 * 60 +
      (parseInt(minute2) || 0) * 60 +
      (parseInt(second2) || 0);
    let resultSeconds;
    if (type === "add") {
      resultSeconds = totalSeconds1 + totalSeconds2;
    } else if (type === "subtract") {
      resultSeconds = totalSeconds1 - totalSeconds2;
    }
    // Check if result is negative
    if (resultSeconds < 0) {
      setError("النتيجة سالبة. الوقت الأول يجب أن يكون أكبر من الوقت الثاني عند الطرح");
      setResult(null);
      return;
    }
    // Convert back to days, hours, minutes, seconds
    const days = Math.floor(resultSeconds / (24 * 60 * 60));
    const hours = Math.floor((resultSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((resultSeconds % (60 * 60)) / 60);
    const seconds = resultSeconds % 60;
    // Calculate additional formats
    const totalHours = Math.floor(resultSeconds / (60 * 60));
    const totalMinutes = Math.floor(resultSeconds / 60);
    const weeks = Math.floor(days / 7);
    const remainingDays = days % 7;
    setResult({
      days,
      hours,
      minutes,
      seconds,
      totalSeconds: resultSeconds,
      totalMinutes,
      totalHours,
      weeks,
      remainingDays,
      time1Total: totalSeconds1,
      time2Total: totalSeconds2,
    });
    setError("");
  };
  const handleClear = () => {
    setDay1("");
    setHour1("");
    setMinute1("");
    setSecond1("");
    setDay2("");
    setHour2("");
    setMinute2("");
    setSecond2("");
    setType("add");
    setResult(null);
    setError("");
  };
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>حاسبة الوقت والزمن</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة الوقت والزمن</strong> أداة مجانية ودقيقة تساعدك
                على <strong>جمع أو طرح</strong> قيم الوقت بسهولة. يمكنك إدخال
                الوقت بالأيام والساعات والدقائق والثواني، والحصول على نتائج
                فورية ودقيقة. مثالية لحساب ساعات العمل، مدة المشاريع، أوقات
                السفر، وأي عمليات حسابية تتعلق بالوقت.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-3 text-center">
              <div className="p-3 mb-3 bg-success text-white rounded text-center">
                <h2 style={{ fontSize: "18px", margin: 0 }}>احسب الفرق بين الأوقات</h2>
              </div>
              {/* Time 1 */}
              <div className="row mb-4 align-items-center">
                <div className="col-md-3"><strong>الوقت الأول:</strong></div>
                <div className="col-md-9 ">
                  <TimeInputGroup day={day1} hour={hour1} min={minute1} sec={second1} setDay={setDay1} setHour={setHour1} setMin={setMinute1} setSec={setSecond1} />
                </div>
              </div>

              {/* Operation */}
              <div className="row mb-4 text-center">
                <div className="col-md-3"><strong>العملية:</strong></div>
                <div className="col-md-9">
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="op" id="add" value="add" checked={type === "add"} onChange={(e) => setType(e.target.value)} />
                    <label className="form-check-label ms-4" htmlFor="add">جمع (+)</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="op" id="sub" value="subtract" checked={type === "subtract"} onChange={(e) => setType(e.target.value)} />
                    <label className="form-check-label ms-4" htmlFor="sub">طرح (−)</label>
                  </div>
                </div>
              </div>

              {/* Time 2 */}
              <div className="row mb-4 align-items-center">
                <div className="col-md-3"><strong>الوقت الثاني:</strong></div>
                <div className="col-md-9">
                  <TimeInputGroup day={day2} hour={hour2} min={minute2} sec={second2} setDay={setDay2} setHour={setHour2} setMin={setMinute2} setSec={setSecond2} />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="text-center my-4">
                <button onClick={handleCalculateTime} className="btn btn-success btn-lg px-5 me-2 ">احسب</button>
                <button onClick={handleClear} className="btn btn-secondary btn-lg px-5" style={{marginRight:'3px'}}style={{marginRight:'3px'}}>امسح</button>
              </div>

              {error && <div className="alert alert-warning shadow-sm"><strong>تنبيه:</strong> {error}</div>}

              {/* Results Table */}
              {result && (
                <div className="result-section mt-5 animate__animated animate__fadeIn">
                  <h3 className="text-center mb-4">النتيجة:</h3>
                  <div className="table-responsive">
                    <table className="table table-bordered text-center shadow-sm">
                      <thead className="table-success text-white">
                        <tr>
                          <th>أيام</th>
                          <th>ساعات</th>
                          <th>دقائق</th>
                          <th>ثواني</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ fontSize: "20px", fontWeight: "bold" }}>
                          <td>{result.days}</td>
                          <td>{result.hours}</td>
                          <td>{result.minutes}</td>
                          <td>{result.seconds}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-6 mb-3">
                      <div className="card h-100">
                        <div className="card-header bg-light fw-bold">تنسيقات إضافية</div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            {result.weeks > 0 && <li>📅 {result.weeks} أسبوع و {result.remainingDays} يوم</li>}
                            <li>⏰ {result.totalHours.toLocaleString()} ساعة</li>
                            <li>⏰ {result.totalMinutes.toLocaleString()} دقيقة</li>
                            <li>⏰ {result.totalSeconds.toLocaleString()} ثانية</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="card h-100">
                        <div className="card-header bg-light fw-bold">تفاصيل الحساب</div>
                        <div className="card-body" style={{ fontSize: "14px" }}>
                          <p>الوقت 1: {result.time1Total.toLocaleString()} ثانية</p>
                          <p>العملية: {type === "add" ? "جمع" : "طرح"}</p>
                          <p>الوقت 2: {result.time2Total.toLocaleString()} ثانية</p>
                          <hr />
                          <p className="fw-bold text-success">الإجمالي: {result.totalSeconds.toLocaleString()} ثانية</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <RelatedLinks />
          </div>
        </div>

        <div className="col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>ما هي حاسبة الوقت والزمن؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>حاسبة الوقت والزمن</strong> هي أداة إلكترونية مجانية
                  تساعدك على إجراء عمليات حسابية على الوقت بطريقة دقيقة وسريعة.
                  تتيح لك الحاسبة:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>جمع فترات زمنية:</strong> إضافة وقتين معاً (مثل جمع
                    ساعات العمل)
                  </li>
                  <li>
                    <strong>طرح فترات زمنية:</strong> حساب الفرق بين وقتين
                  </li>
                  <li>
                    <strong>التعامل مع وحدات متعددة:</strong> الأيام، الساعات،
                    الدقائق، والثواني
                  </li>
                  <li>
                    <strong>التحويل التلقائي:</strong> تحويل النتائج إلى صيغ
                    مختلفة
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيفية استخدام الحاسبة:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل الوقت الأول بالأيام والساعات والدقائق والثواني</li>
                  <li>اختر العملية (جمع أو طرح)</li>
                  <li>أدخل الوقت الثاني بنفس الطريقة</li>
                  <li>اضغط على زر "احسب"</li>
                  <li>ستظهر النتيجة فوراً بتنسيقات متعددة</li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 ملاحظة:</strong> يمكنك ترك أي حقل فارغاً، وسيتم
                  اعتباره صفراً تلقائياً. مثلاً، إذا أردت جمع 2 ساعة و30 دقيقة،
                  اترك حقول الأيام والثواني فارغة.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>استخدامات حاسبة الوقت</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  في العمل والأعمال:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>حساب ساعات العمل:</strong> جمع ساعات العمل اليومية
                    أو الأسبوعية
                  </li>
                  <li>
                    <strong>إدارة المشاريع:</strong> حساب المدة الإجمالية
                    للمشروع
                  </li>
                  <li>
                    <strong>جدولة المواعيد:</strong> حساب وقت الاجتماعات والفعاليات
                  </li>
                  <li>
                    <strong>حساب الإجازات:</strong> جمع أيام الإجازة المتراكمة
                  </li>
                  <li>
                    <strong>الفواتير:</strong> حساب ساعات العمل لإصدار الفواتير
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في التعليم والتدريب:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>حساب ساعات الدراسة:</strong> تتبع وقت الدراسة والمراجعة
                  </li>
                  <li>
                    <strong>مدة الدورات التدريبية:</strong> حساب إجمالي ساعات
                    التدريب
                  </li>
                  <li>
                    <strong>جداول الامتحانات:</strong> حساب وقت الامتحانات
                  </li>
                  <li>
                    <strong>تخطيط المناهج:</strong> توزيع الوقت على المواد
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في الحياة اليومية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>أوقات السفر:</strong> حساب مدة الرحلات والرحلات
                  </li>
                  <li>
                    <strong>الطبخ والخبز:</strong> جمع أوقات التحضير والطهي
                  </li>
                  <li>
                    <strong>الرياضة:</strong> حساب وقت التمرين الإجمالي
                  </li>
                  <li>
                    <strong>النوم:</strong> تتبع ساعات النوم
                  </li>
                  <li>
                    <strong>الأنشطة الترفيهية:</strong> حساب وقت الهوايات
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في المجال الطبي:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>مدة العمليات الجراحية:</strong> حساب وقت الجراحة
                  </li>
                  <li>
                    <strong>فترات العلاج:</strong> حساب مدة العلاج الطبيعي أو
                    الدوائي
                  </li>
                  <li>
                    <strong>مواعيد الأدوية:</strong> حساب فترات تناول الدواء
                  </li>
                  <li>
                    <strong>نوبات العمل:</strong> حساب ساعات عمل الأطباء
                    والممرضين
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>فهم وحدات الوقت</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  لفهم كيفية عمل حاسبة الوقت، من المهم معرفة العلاقات بين
                  وحدات الوقت المختلفة:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  وحدات الوقت الأساسية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>الثانية (ث):</strong> الوحدة الأساسية للوقت في النظام
                    الدولي
                  </li>
                  <li>
                    <strong>الدقيقة (د):</strong> 1 دقيقة = 60 ثانية
                  </li>
                  <li>
                    <strong>الساعة (س):</strong> 1 ساعة = 60 دقيقة = 3,600 ثانية
                  </li>
                  <li>
                    <strong>اليوم:</strong> 1 يوم = 24 ساعة = 1,440 دقيقة = 86,400
                    ثانية
                  </li>
                  <li>
                    <strong>الأسبوع:</strong> 1 أسبوع = 7 أيام = 168 ساعة
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  جدول التحويل السريع:
                </h3>
                <div>
                  <table>
                    <thead>
                      <tr>
                        <th>من</th>
                        <th>إلى</th>
                        <th>المعادلة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>دقيقة</td>
                        <td>ثانية</td>
                        <td>× 60</td>
                      </tr>
                      <tr>
                        <td>ساعة</td>
                        <td>دقيقة</td>
                        <td>× 60</td>
                      </tr>
                      <tr>
                        <td>ساعة</td>
                        <td>ثانية</td>
                        <td>× 3,600</td>
                      </tr>
                      <tr>
                        <td>يوم</td>
                        <td>ساعة</td>
                        <td>× 24</td>
                      </tr>
                      <tr>
                        <td>يوم</td>
                        <td>دقيقة</td>
                        <td>× 1,440</td>
                      </tr>
                      <tr>
                        <td>يوم</td>
                        <td>ثانية</td>
                        <td>× 86,400</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيف تعمل الحاسبة:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>تحول جميع القيم المدخلة إلى ثواني</li>
                  <li>تجري العملية الحسابية (جمع أو طرح) على إجمالي الثواني</li>
                  <li>تحول النتيجة مرة أخرى إلى أيام وساعات ودقائق وثواني</li>
                  <li>تعرض النتيجة بتنسيقات مختلفة لسهولة الاستخدام</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>أمثلة عملية على استخدام حاسبة الوقت</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  مثال 1: حساب ساعات العمل الأسبوعية
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>المشكلة:</strong> عملت 7 ساعات و45 دقيقة يومياً لمدة 5
                  أيام. كم ساعة عملت في الأسبوع؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل الوقت الأول: 0 يوم، 7 ساعات، 45 دقيقة، 0 ثانية</li>
                  <li>اختر "جمع"</li>
                  <li>أدخل نفس الوقت 4 مرات إضافية (أو اضرب النتيجة × 5)</li>
                  <li>
                    النتيجة: 1 يوم، 14 ساعات، 45 دقيقة (أو 38 ساعة و45 دقيقة)
                  </li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 2: حساب وقت الرحلة
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>المشكلة:</strong> رحلتك تتكون من رحلة طيران 5 ساعات
                  و30 دقيقة، فترة انتظار 2 ساعة و15 دقيقة، ورحلة طيران أخرى 3
                  ساعات و50 دقيقة. كم إجمالي وقت الرحلة؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل الوقت الأول: 0 يوم، 5 ساعات، 30 دقيقة، 0 ثانية</li>
                  <li>اختر "جمع"</li>
                  <li>أدخل الوقت الثاني: 0 يوم، 2 ساعات، 15 دقيقة، 0 ثانية</li>
                  <li>النتيجة: 7 ساعات و45 دقيقة</li>
                  <li>كرر مع الرحلة الثالثة للحصول على الإجمالي النهائي</li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 3: حساب الوقت المتبقي في المشروع
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>المشكلة:</strong> مشروعك يتطلب 40 ساعة عمل، وقد عملت
                  حتى الآن 28 ساعة و30 دقيقة. كم الوقت المتبقي؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong>
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل الوقت الأول: 1 يوم، 16 ساعة، 0 دقيقة، 0 ثانية (40 ساعة)</li>
                  <li>اختر "طرح"</li>
                  <li>أدخل الوقت الثاني: 1 يوم، 4 ساعات، 30 دقيقة، 0 ثانية (28.5 ساعة)</li>
                  <li>النتيجة: 0 يوم، 11 ساعة، 30 دقيقة، 0 ثانية</li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 4: حساب وقت التمرين
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>المشكلة:</strong> تمرينك اليومي يتكون من: 15 دقيقة إحماء، 45 دقيقة تمارين رئيسية، 20 دقيقة تمارين قوة، 10 دقائق تهدئة. كم إجمالي وقت التمرين؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong> اجمع جميع الأوقات للحصول على 1 ساعة و30 دقيقة
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>نصائح لاستخدام حاسبة الوقت بفعالية</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  نصائح عامة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>استخدم الوحدة المناسبة:</strong> اختر الوحدة التي
                    تناسب سياق استخدامك (أيام للمشاريع الطويلة، ساعات للعمل
                    اليومي)
                  </li>
                  <li>
                    <strong>تحقق من المدخلات:</strong> تأكد من إدخال القيم
                    الصحيحة قبل الحساب
                  </li>
                  <li>
                    <strong>الحقول الفارغة = صفر:</strong> لا داعي لملء جميع
                    الحقول، اترك ما لا تحتاجه فارغاً
                  </li>
                  <li>
                    <strong>استخدم التنسيقات المتعددة:</strong> راجع النتيجة
                    بتنسيقات مختلفة لاختيار الأنسب
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  لتجنب الأخطاء:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>تذكر أن الساعة لها 60 دقيقة (وليس 100)</li>
                  <li>الدقيقة لها 60 ثانية (وليس 100)</li>
                  <li>اليوم له 24 ساعة</li>
                  <li>عند الطرح، تأكد أن الوقت الأول أكبر من الثاني</li>
                  <li>استخدم قيماً موجبة فقط</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  للاستخدام الاحترافي:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>احتفظ بسجل للحسابات المهمة</li>
                  <li>التقط صورة للشاشة للرجوع إليها لاحقاً</li>
                  <li>استخدم الحاسبة مع جداول البيانات لتحليل أفضل</li>
                  <li>راجع النتائج بتنسيقات مختلفة للتأكد من الدقة</li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ ميزة:</strong> حاسبة الوقت تعمل بشكل فوري وبدون
                  الحاجة للإنترنت بعد تحميل الصفحة، مما يجعلها مثالية للاستخدام
                  في أي مكان!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>معلومات مثيرة عن الوقت</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  حقائق ممتعة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>الساعة الذرية:</strong> أدق ساعة في العالم قد تخطئ
                    بثانية واحدة كل 100 مليون سنة!
                  </li>
                  <li>
                    <strong>الثانية الكبيسة:</strong> يتم إضافة ثانية كبيسة
                    أحياناً لمزامنة الساعات الذرية مع دوران الأرض
                  </li>
                  <li>
                    <strong>الزمن النسبي:</strong> وفقاً لنظرية أينشتاين،
                    الوقت يمر أبطأ كلما زادت السرعة أو الجاذبية
                  </li>
                  <li>
                    <strong>في الفضاء:</strong> رواد الفضاء يعيشون أبطأ بجزء من
                    الثانية بسبب سرعتهم العالية
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  أرقام مثيرة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>في السنة: 31,536,000 ثانية تقريباً</li>
                  <li>في اليوم: 86,400 ثانية</li>
                  <li>في الساعة: 3,600 ثانية</li>
                  <li>الإنسان يقضي ثلث حياته نائماً (حوالي 229,961 ساعة في 80 عاماً)</li>
                  <li>متوسط عمر الإنسان: حوالي 700,800 ساعة (80 سنة)</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في ثقافات مختلفة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>التقويم الصيني:</strong> يستخدم دورات 60 عاماً
                  </li>
                  <li>
                    <strong>التقويم المايا:</strong> كان دقيقاً جداً ومعقداً
                  </li>
                  <li>
                    <strong>القدماء المصريون:</strong> كانوا من أوائل من قسموا
                    اليوم إلى 24 ساعة
                  </li>
                  <li>
                    <strong>البابليون:</strong> أول من استخدم نظام الـ 60 (60
                    دقيقة، 60 ثانية)
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            أسئلة متكررة
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أستخدم حاسبة الوقت؟
                </h3>
              </div>
              <div className="info-section-body">
                استخدام حاسبة الوقت بسيط جداً:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    أدخل الوقت الأول في الحقول المخصصة (يمكنك ترك أي حقل فارغاً
                    إذا لم تحتاجه)
                  </li>
                  <li>اختر العملية: جمع (+) أو طرح (−)</li>
                  <li>أدخل الوقت الثاني بنفس الطريقة</li>
                  <li>اضغط على زر "احسب"</li>
                  <li>
                    ستظهر النتيجة فوراً في جدول واضح، مع تنسيقات إضافية في
                    الأقسام القابلة للتوسيع
                  </li>
                </ol>
                الحقول الفارغة تُعامل تلقائياً كصفر، لذا لا داعي لملء جميع
                الحقول.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما الفرق بين جمع وطرح الوقت؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>جمع الوقت (+):</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>يُستخدم لإضافة فترتين زمنيتين معاً</li>
                  <li>
                    مثال: 2 ساعة + 3 ساعة = 5 ساعات (حساب إجمالي ساعات العمل)
                  </li>
                  <li>
                    مفيد لحساب المجموع الكلي لفترات متعددة
                  </li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "10px" }}>
                  <strong>طرح الوقت (−):</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>يُستخدم لحساب الفرق بين وقتين</li>
                  <li>
                    مثال: 5 ساعات − 2 ساعة = 3 ساعات (حساب الوقت المتبقي)
                  </li>
                  <li>
                    الوقت الأول يجب أن يكون أكبر من الوقت الثاني لتجنب النتائج
                    السالبة
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكنني استخدام الحاسبة لحساب ساعات العمل؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم! حاسبة الوقت مثالية لحساب ساعات العمل. يمكنك:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>حساب اليوم الواحد:</strong> أدخل وقت البداية والنهاية
                    واطرحهما
                  </li>
                  <li>
                    <strong>جمع عدة أيام:</strong> احسب ساعات كل يوم ثم اجمعها
                  </li>
                  <li>
                    <strong>حساب الأسبوع:</strong> اضرب ساعات اليوم الواحد في
                    عدد أيام العمل
                  </li>
                  <li>
                    <strong>طرح فترات الراحة:</strong> اطرح وقت الغداء أو
                    الاستراحة من إجمالي الوقت
                  </li>
                </ul>
                النتيجة ستظهر بعدة تنسيقات مفيدة للفواتير وكشوف الرواتب.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  لماذا الساعة 60 دقيقة وليست 100؟
                </h3>
              </div>
              <div className="info-section-body">
                السبب يعود إلى البابليين القدماء الذين استخدموا النظام
                الستيني (القاعدة 60) منذ آلاف السنين:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>سهولة القسمة:</strong> الرقم 60 يقبل القسمة على 1،
                    2، 3، 4، 5، 6، 10، 12، 15، 20، 30، 60
                  </li>
                  <li>
                    <strong>الرياضيات الفلكية:</strong> يتناسب مع حسابات الفلك
                    والتقويم
                  </li>
                  <li>
                    <strong>التقليد التاريخي:</strong> استمر استخدامه عبر
                    الحضارات لفعاليته
                  </li>
                </ul>
                هذا النظام ما زال يُستخدم حتى اليوم في قياس الوقت والزوايا!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل الحاسبة دقيقة؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، حاسبة الوقت دقيقة جداً. تستخدم الحاسبة:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>خوارزميات دقيقة:</strong> تحويل كل شيء إلى ثواني
                    ثم العودة للتنسيق المطلوب
                  </li>
                  <li>
                    <strong>معالجة صحيحة للتحويلات:</strong> تأخذ في الاعتبار
                    60 ثانية في الدقيقة، 60 دقيقة في الساعة، 24 ساعة في اليوم
                  </li>
                  <li>
                    <strong>حسابات فورية:</strong> نتائج لحظية بدون أخطاء
                    تقريب
                  </li>
                  <li>
                    <strong>التحقق من الصحة:</strong> تنبهك إذا أدخلت قيماً غير
                    صحيحة
                  </li>
                </ul>
                يمكنك الاعتماد على النتائج بثقة تامة للاستخدامات المهنية
                والشخصية.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماذا لو حصلت على نتيجة سالبة؟
                </h3>
              </div>
              <div className="info-section-body">
                إذا حصلت على رسالة خطأ تفيد بأن "النتيجة سالبة"، فهذا يعني:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    عند اختيار عملية <strong>الطرح</strong>، الوقت الثاني أكبر
                    من الوقت الأول
                  </li>
                  <li>لحل المشكلة، لديك خياران:</li>
                  <ul>
                    <li>
                      <strong>خيار 1:</strong> اعكس المدخلات (اجعل الوقت الكبير
                      أولاً)
                    </li>
                    <li>
                      <strong>خيار 2:</strong> غيّر العملية من "طرح" إلى "جمع"
                      إذا كنت تريد الجمع
                    </li>
                  </ul>
                </ul>
                مثال: إذا أدخلت 2 ساعة − 5 ساعات، الحاسبة ستنبهك. الحل: أدخل 5
                ساعات − 2 ساعة = 3 ساعات.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أحول النتيجة إلى تنسيق مختلف؟
                </h3>
              </div>
              <div className="info-section-body">
                بعد الحصول على النتيجة، انقر على قسم "تنسيقات إضافية للنتيجة"
                لرؤية النتيجة بطرق مختلفة:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>بالأسابيع والأيام:</strong> مفيد للمشاريع الطويلة
                  </li>
                  <li>
                    <strong>إجمالي الساعات:</strong> مفيد لحساب الفواتير
                  </li>
                  <li>
                    <strong>إجمالي الدقائق:</strong> مفيد للمهام القصيرة
                  </li>
                  <li>
                    <strong>إجمالي الثواني:</strong> للدقة القصوى
                  </li>
                </ul>
                اختر التنسيق الذي يناسب احتياجاتك!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكنني استخدام الحاسبة على الهاتف؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم! حاسبة الوقت مصممة لتعمل بكفاءة على جميع الأجهزة:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>الهواتف الذكية:</strong> واجهة متجاوبة تتكيف مع
                    الشاشات الصغيرة
                  </li>
                  <li>
                    <strong>الأجهزة اللوحية:</strong> تجربة مثالية للشاشات
                    المتوسطة
                  </li>
                  <li>
                    <strong>أجهزة الكمبيوتر:</strong> استفادة من المساحة الكبيرة
                  </li>
                </ul>
                الحاسبة تعمل بشكل فوري بدون الحاجة للإنترنت بعد تحميل الصفحة،
                مما يجعلها مثالية للاستخدام في أي مكان!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TimeCalculator;